import React, { useEffect } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deleteClothIssue } from '../../Store/PHPSlice/Cutting/clothIssue';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import axios from 'axios';

const TableBody = ({
    serialNumber,
    id,
    srno,
    dt,
    fpkmemo,
    itemId,
    itemNm,
    firmId,
    firmNm,
    empNm,
    sono,
    orderno,
    soId,
    ordtype,
    sts,
    prnId,
    prnMemo,
    stinwId,
    streMemo,
    mclothNm,
    m1clothNm,
    m2clothNm,
    m3clothNm,
    instruction,
    totqty,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.origin !== window.location.origin) return;

            if (event.data === "REFRESH_PARENT") {
                window.location.reload();
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const handleDeleteClick = () => {
        // Show confirmation dialog

        const isConfirmed = window.confirm("Delete this packing?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            deleteFlowPack(id, userdata.ID);
        }

    };

    const deleteFlowPack = async (id, userId) => {
        try {
            const res = await axios.delete(`${baseUrl}?apicall=deletePackFlowEntry&pkid=${id}&userId=${userId}`);
            if (res.data === "success") {
                alert(res.data.msg);
                window.location.reload();
            } else {
                alert(res.data.msg);
            }
        } catch (error) {
            console.error('error', error);
        }
    };

    const handleViewClick = () => {
        window.open(`/pack-flow-info/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };



    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothIssueEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

    const handleReturnClick = () => {
        window.open(`/pack-flow-inward/${id}`, '_blank', 'width=1200,height=700,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {fpkmemo}
                </TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {ordtype}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sono}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {orderno}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {empNm}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {itemNm}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {totqty}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon className='cursor-pointer' onClick={handleViewClick} />
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <Button className='cursor-pointer' variant="contained" color="primary" disabled={sts === '1'} onClick={handleReturnClick}>Inward</Button>
                </TableCell>

                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} />
                </TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
